import React, { Component } from 'react';
import { withRouter, Redirect, Link } from "react-router-dom";
import { Text, View, Image, ScrollView, Platform } from 'react-native';
import WriterSingle from '../../native/screens/writer-single';
import ReactGA from 'react-ga';

export class WriterSingleScreen extends Component {
    constructor(props) {
        super(props);
        let postData = (process.browser) ? document.getElementById("postData") : null;
        let footerData = (process.browser) ? document.getElementById("footerData") : null;
        this.state = {
            searchQuery: "",
            locationHash: "",
            writerSlug: this.props.match.params.writer_slug,
            writerData: (postData) ? JSON.parse(postData.getAttribute('data')) : ((JSON.stringify(this.props.postData)) ? this.props.postData : null),
            footerData: (footerData) ? JSON.parse(footerData.getAttribute('data')) : ((JSON.stringify(this.props.footerData)) ? this.props.footerData : null)
        }
        if(process.browser) {
            if(postData) {
                postData.parentNode.removeChild(postData);
            }
            if(footerData) {
                footerData.parentNode.removeChild(footerData);
            }
            try {
                ReactGA.pageview(this.props.history.location.pathname);
            }
            catch(error) {
                console.log("GA tracking error =>", error);
            }
        }
    }

    componentDidMount = () => {
        setTimeout(function () {
            window.history.scrollRestoration = "manual";
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            setTimeout(function () {
                document.body.style.overflow = 'initial';
                document.body.style.position = 'initial';
            }, 20);
        }, 20);
        if(window.location.search != this.state.searchQuery) {
            this.setState({
                searchQuery: window.location.search
            })
        }
        if(window.location.hash != this.state.locationHash) {
            this.setState({
                locationHash: window.location.hash
            })
        }
    }

    componentDidUpdate = () => {
        if(window.location.search != this.state.searchQuery) {
            this.setState({
                searchQuery: window.location.search
            })
        }
        if(window.location.hash != this.state.locationHash) {
            this.setState({
                locationHash: window.location.hash
            })
        }
        if(this.state.writerSlug != this.props.match.params.writer_slug) {
            this.setState({
                writerSlug: this.props.match.params.writer_slug,
                writerData: null,
                footerData: null
            })
        }
    }

    navigateToScreen = (route, params) => {
        let routeArr = route.split('?')
        const { history } = this.props;
        history.push({
          pathname: routeArr[0],
          search: routeArr[1] ? ('?' + routeArr[1]) : '',
          state: params
        });
    }

    render() {
        const { writerSlug, writerData, footerData, searchQuery, locationHash,authorArticleList,authorArticleData } = this.state;

        return (
            <WriterSingle history={this.props.history} searchQuery={searchQuery} locationHash={locationHash} key={writerSlug} navigateToScreen={this.navigateToScreen} writerData={writerData} writerSlug={writerSlug} footerData={footerData} />
        );
    }
}

export default withRouter(WriterSingleScreen);